// material-ui
import { Box, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import PropTypes from 'prop-types';

// project import
// import Search from './Search';
import Profile from './Profile';
// import Notification from './Notification';
import MobileSection from './MobileSection';
import { useTheme } from '@mui/material/styles';

import { useSelector, useDispatch } from 'react-redux';
import { openFilterDrawer } from 'store/slices/menu';
import SimplifiedLogo from 'components/Logo/SimplifiedLogo';
const HeaderContent = ({ open }) => {
    const theme = useTheme();
    const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const menu = useSelector((state) => state.menu);
    const dashboard = useSelector((state) => state.dashboard);
    const dispatch = useDispatch();

    return (
        <>
            {/* {!matchesXs && <Search />}
            {matchesXs && (
                <Box sx={{ width: '100%', ml: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <SimplifiedLogo sx={{ width: '120px !important' }} />
                </Box>
            )} */}
            <Box sx={{ width: '100%', ml: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {!open && <SimplifiedLogo sx={{ width: '120px !important' }} />}
            </Box>
            {menu.filter.enabled && (
                <ToggleButtonGroup value={menu.filter.opened}>
                    <ToggleButton
                        value={true}
                        onClick={() => {
                            dispatch(openFilterDrawer());
                        }}
                        // component={Link}
                        // href="#"
                        // target="_blank"
                        disableRipple
                        color="secondary"
                        title="Filtrar conteúdo"
                        sx={{
                            color: 'text.primary',
                            bgcolor: dashboard.filters.store.length > 0 ? 'primary.light' : 'grey.100',
                            width: theme.spacing(4.5),
                            height: theme.spacing(4.5)
                        }}
                    >
                        <FilterAltOutlinedIcon fontSize="small" />
                    </ToggleButton>
                </ToggleButtonGroup>
            )}

            {/* <Notification /> */}
            {!matchesXs && <Profile />}
            {matchesXs && <MobileSection />}
        </>
    );
};

HeaderContent.propTypes = {
    open: PropTypes.bool
};

export default HeaderContent;
